import React, { useState, useEffect } from 'react';
import Menu from '../Menu'
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import '../App.css'


const MyShareDetails = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editRecord, setEditRecord] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const mytoken = sessionStorage.getItem('google_token');
    const { platform,symbol } = useParams();
    const navigate = useNavigate();
    const [filterValue, setFilterValue] = useState(""); // State to hold filter input
    const [symbolSel, setSymbolSel] = useState(""); // State to hold filter input
    const [filterKey, setFilterKey] = useState(""); // Key to filter by (default:
    const [sum, setSum] = useState(0);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const filteredData = data.filter((item) => {
        if (!filterValue) return true; // If no filter, show all data
        const itemValue = item[filterKey]?.toString().toLowerCase(); // Convert item value to string for comparison
        return itemValue === filterValue.toLowerCase();
    });

    // Sort the filtered data based on sortConfig
    const sortedData = [...filteredData].sort((a, b) => {
        if (!sortConfig.key) return 0;

        // Handle date sorting for data_ach
        if (sortConfig.key === 'data_ach') {
            const aDate = new Date(a[sortConfig.key] || 0);
            const bDate = new Date(b[sortConfig.key] || 0);
            if (sortConfig.direction === 'asc') {
                return aDate - bDate;
            } else {
                return bDate - aDate;
            }
        }

        // Handle numeric sorting for other columns
        const aValue = parseFloat(a[sortConfig.key]) || 0;
        const bValue = parseFloat(b[sortConfig.key]) || 0;

        if (sortConfig.direction === 'asc') {
            return aValue - bValue;
        } else {
            return bValue - aValue;
        }
    });

    // Handle column header click for sorting
    const handleSort = (key) => {
        setSortConfig((prevConfig) => ({
            key,
            direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
        }));
    };

    // Get CSS class for sortable column header
    const getSortClass = (key) => {
        let className = 'sortable';
        if (sortConfig.key === key) {
            className += ' ' + sortConfig.direction;
        }
        return className;
    };

    const [platforms] = useState([
        { code: "bttrade", name: "bttrade"},
        { code: "etoro", name: "etoro"},
        { code: "goldring", name: "goldring"},
        { code: "IBKR", name: "IBKR"},
        { code: "trading212", name: "trading212"},
        { code: "XTBEUR", name: "XTBEUR"},
        { code: "XTBUSD", name: "XTBUSD"}
      ]);

    const [formAdd, setFormAdd] = useState({
        symb: '',
        platform: '',
        nrunits: '',
        valnow: '',
        valinvact: '',
        valc: '',
        currency: '',
        symb_platform: '',
        data_ach: ''

    });

    const copyValues = () => {
        setFormAdd(editRecord);
    };

    const deleteRecord = async () => {
        const userConfirmed = window.confirm("Are you sure you want to delete ?");
        if (!userConfirmed) {
            return;
        }
        setIsLoading(true);
        setError(null);
        try {
            // Send PUT request to update the record
            const response = await fetch(`https://app64.heliohost.us/api/updateMyShareDetails.php?id=${editRecord.id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "AuthCode": mytoken
                }
            });

            if (!response.ok) {
                throw new Error("Failed to update the record.");
            }

            const updatedRecord = await response.json();

            // Update the local state
            setData((prevRecords) =>
                prevRecords.map((rec) =>
                    rec.id === updatedRecord.id ? updatedRecord : rec
                )
            );
            setEditRecord(null); // Close the form after saving
            window.location.reload();

        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };




    useEffect(() => {

        console.log(`Parameter changed! Now showing item with ID: ${platform} ${symbol}`);

        // Replace with your API endpoint
        if (typeof symbol !== "undefined") {
            setSymbolSel(symbol)   ;
        }


        var apiUrl = 'https://app64.heliohost.us/api/getMySharesDetails.php';
        if (typeof platform !== "undefined") {
        
            apiUrl = 'https://app64.heliohost.us/api/getMySharesDetails.php?platform=' + platform;
            if (typeof symbol !== "undefined") {
                apiUrl=apiUrl+"&symbol="+symbol;
            }
        }
        //const apiUrl = 'http://localhost/api/getShareAlarms.php';


        fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "AuthCode": mytoken
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return response.json();
            })
            .then((data) => {
                setData(data);
                setLoading(false);
                if (typeof platform !== "undefined") {
                    setFilterValue(platform);
                    setFilterKey("platform");

                }

                const totalSum = data.reduce((sum, item) => sum + item.nrunits*item.valnow, 0);
                setSum(totalSum.toFixed(2));
                

            })
            .catch((error) => {
                console.error("Error:", error);
                setError(error.message);
                setLoading(false);
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty dependency array means this runs once on component mount

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }


    const handleEditClick = (record) => {
        setEditRecord(record); // Set the record to be edited
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditRecord({ ...editRecord, [name]: value });
    };

    const handleSymbChange = (e) => {
        setSymbolSel(e.target.value);
    };

    const changePlatform = (e) => {
        navigate(`/mysharesdet/${platform}/${symbolSel}`); 
        window.location.reload();
    };


    
    


    const handleInputChangeAdd = (e) => {
        const { name, value } = e.target;
        setFormAdd({ ...formAdd, [name]: value });
    };


    const handleSelectChange = (event) => {
        const selectedValue = event.target.value;

        if (selectedValue) {
            if(symbol===""){
            navigate(`/mysharesdet/${selectedValue}`);
            }else{
                navigate(`/mysharesdet/${selectedValue}/${symbolSel}`);
            }
            window.location.reload();
        }

    };


    const handleSave = async () => {
        setIsLoading(true);
        setError(null);
        try {
            // Send PUT request to update the record
            // ?id=${editRecord.id}
            const response = await fetch(`https://app64.heliohost.us/api/updateMyShareDetails.php`, {                
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "AuthCode": mytoken
                },
                body: JSON.stringify(editRecord),
            });

            if (!response.ok) {
                throw new Error("Failed to update the record.");
            }

            const updatedRecord = await response.json();

            // Update the local state
            setData((prevRecords) =>
                prevRecords.map((rec) =>
                    rec.id === updatedRecord.id ? updatedRecord : rec
                )
            );
            setEditRecord(null); // Close the form after saving
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleAdd = async () => {
        setIsLoading(true);
        setError(null);
        try {
            // Send POST request to update the record
            const response = await fetch(`https://app64.heliohost.us/api/updateMyShareDetails.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "AuthCode": mytoken
                },
                body: JSON.stringify(formAdd),
            });

            if (!response.ok) {
                throw new Error("Failed to update the record.");
            }

            const updatedRecord = await response.json();

            // Update the local state
            setData((prevRecords) =>
                prevRecords.map((rec) =>
                    rec.id === updatedRecord.id ? updatedRecord : rec
                )
            );
            setEditRecord(null); // Close the form after saving

        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div>
            <Menu />
            <h1 className="page-title">Share Details</h1>

            {editRecord && (
                <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setEditRecord(null)}>
                    <div className="modal-content">
                        <h2>
                            Edit Record
                            <button className="btn-close" onClick={() => setEditRecord(null)}>×</button>
                        </h2>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSave();
                            }}
                        >
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Symbol</label>
                                    <input
                                        type="text"
                                        name="symb"
                                        value={editRecord.symb}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Platform</label>
                                    <input
                                        type="text"
                                        name="platform"
                                        value={editRecord.platform}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Date Bought</label>
                                    <input
                                        type="date"
                                        name="data_ach"
                                        value={editRecord.data_ach}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Units</label>
                                    <input
                                        type="text"
                                        name="nrunits"
                                        value={editRecord.nrunits}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Initial Value</label>
                                    <input
                                        type="text"
                                        name="valinitact"
                                        value={editRecord.valinitact}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Value Now</label>
                                    <input
                                        type="text"
                                        name="valnow"
                                        value={editRecord.valnow}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Currency</label>
                                    <select
                                        name="currency"
                                        value={editRecord.currency}
                                        onChange={handleInputChange}
                                    >
                                        <option value="USD">USD</option>
                                        <option value="EUR">EUR</option>
                                        <option value="RON">RON</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Active</label>
                                    <input
                                        type="text"
                                        name="isactive"
                                        value={editRecord.isactive}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <div className="button-group">
                                <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                    {isLoading ? "Saving..." : "Save"}
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={() => setEditRecord(null)}>
                                    Cancel
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={copyValues}>
                                    Clone
                                </button>
                                <button type="button" className="btn btn-danger" onClick={deleteRecord}>
                                    Delete
                                </button>
                            </div>
                        </form>
                        {error && <p className="error-message">{error}</p>}
                    </div>
                </div>
            )}


            <div className="form-card">
                <h2>Add Record</h2>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleAdd();
                    }}
                >
                    <div className="form-row">
                        <div className="form-group">
                            <label>Symbol</label>
                            <input
                                type="text"
                                name="symb"
                                value={formAdd.symb}
                                onChange={handleInputChangeAdd}
                            />
                        </div>
                        <div className="form-group">
                            <label>Platform</label>
                            <select
                                name="platform"
                                value={formAdd.platform}
                                onChange={handleInputChangeAdd}
                            >
                                <option value="-">-</option>
                                {platforms.map((item) => (
                                    <option key={item.code} value={item.code}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Date Bought</label>
                            <input
                                type="date"
                                name="data_ach"
                                value={formAdd.data_ach}
                                onChange={handleInputChangeAdd}
                            />
                        </div>
                        <div className="form-group">
                            <label>Units</label>
                            <input
                                type="text"
                                name="nrunits"
                                value={formAdd.nrunits}
                                onChange={handleInputChangeAdd}
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Initial Value</label>
                            <input
                                type="text"
                                name="valinitact"
                                value={formAdd.valinitact}
                                onChange={handleInputChangeAdd}
                            />
                        </div>
                        <div className="form-group">
                            <label>Value Now</label>
                            <input
                                type="text"
                                name="valnow"
                                value={formAdd.valnow}
                                onChange={handleInputChangeAdd}
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Currency</label>
                            <select
                                name="currency"
                                value={formAdd.currency}
                                onChange={handleInputChangeAdd}
                            >
                                <option value="USD">USD</option>
                                <option value="EUR">EUR</option>
                                <option value="RON">RON</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Symb Platform</label>
                            <input
                                type="text"
                                name="symb_platform"
                                value={formAdd.symb_platform}
                                onChange={handleInputChangeAdd}
                            />
                        </div>
                    </div>

                    <div>
                        <button type="submit" className="btn btn-primary" disabled={isLoading}>
                            {isLoading ? "Adding..." : "Add"}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={() => setEditRecord(null)}>
                            Cancel
                        </button>
                    </div>
                </form>
                {error && <p className="error-message">{error}</p>}
            </div>
            <div>
                <br/>
            </div>        
            <div>
                <div>
                    <select name="platformsel" id="platform-select" value={platform} onChange={handleSelectChange}>
                        <option value="">--Select--</option>
                        {platforms.map((item) => (
                                        <option key={item.code} value={item.code}>
                                            {item.name}
                                        </option>
                                    ))}
                    </select>
                    <button type="button" onClick={changePlatform}>
                            Change
                        </button>
                </div>
                <div>
                    <input type='text' value={symbolSel} onChange={handleSymbChange}/><br/>
                </div>

            </div>
            <div className="table-container">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Symbol</th>
                            <th>Platform</th>
                            <th onClick={() => handleSort('nrunits')} className={getSortClass('nrunits')}>Units</th>
                            <th>Val Now</th>
                            <th>Val Init</th>
                            <th onClick={() => handleSort('valtnow')} className={getSortClass('valtnow')}>Total Now</th>
                            <th onClick={() => handleSort('valtinit')} className={getSortClass('valtinit')}>Total Init</th>
                            <th onClick={() => handleSort('procent')} className={getSortClass('procent')}>%</th>
                            <th onClick={() => handleSort('cagr')} className={getSortClass('cagr')}>CAGR</th>
                            <th onClick={() => handleSort('period_month')} className={getSortClass('period_month')}>Months</th>
                            <th onClick={() => handleSort('data_ach')} className={getSortClass('data_ach')}>Bought</th>
                            <th>Sold</th>
                            <th>Curr</th>
                            <th>Active</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.map((item) => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.symb}</td>
                                <td>{item.platform}</td>
                                <td>{item.nrunits}</td>
                                <td>{item.valnow}</td>
                                <td>{item.valinitact}</td>
                                <td>{item.valtnow}</td>
                                <td>{item.valtinit}</td>
                                <td><strong>{item.procent}</strong></td>
                                <td><strong>{item.cagr}</strong></td>
                                <td>{item.period_month}</td>
                                <td>{item.data_ach}</td>
                                <td>{item.data_sell}</td>
                                <td>{item.currency}</td>
                                <td>{item.isactive}</td>
                                <td><button className="btn-edit" onClick={() => handleEditClick(item)}>Edit</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div style={{ marginTop: '15px', fontSize: '1.1rem', color: '#667eea', fontWeight: '600' }}>
                Total: {sum}
            </div>



        </div>
    );
}


export default MyShareDetails